import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'analytics-test-overview';

export const SELECT_BY_VERSION = `${NAMESPACE}/SELECT_BY_VERSION`;
export const CLEAR_SELECT_BY_VERSION = `${NAMESPACE}/CLEAR_SELECT_BY_VERSION`;
export const SORT_TEST_CASES = `${NAMESPACE}/SORT_TEST_CASES`;
export const SET_TEST_CASE_QUERY = `${NAMESPACE}/SET_TEST_CASE_QUERY`;
export const CLEANUP_OVERVIEW = `${NAMESPACE}/CLEANUP_OVERVIEW`;

const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const GET_ORGANIZATION = createApiNamespacedConstants('GET_ORGANIZATION');
export const GET_TEST_TRENDS = createApiNamespacedConstants('GET_TEST_TRENDS');
export const GET_PAST_TRENDS = createApiNamespacedConstants('GET_PAST_TRENDS');
export const GET_PAST_AGGREGATED_TEST_ERRORS = createApiNamespacedConstants('GET_PAST_AGGREGATED_TEST_ERRORS');
export const GET_TEST_HEALTH = createApiNamespacedConstants('GET_TEST_HEALTH');
export const GET_PAST_HEALTH = createApiNamespacedConstants('GET_PAST_HEALTH');
